import { Phone, Mail, MapPin } from 'lucide-react';

export default function TopBar() {
  return (
    <div className="bg-[#D4AF37] border-b border-white/5 py-2">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-row items-center justify-end gap-2 sm:gap-6 text-xs sm:text-sm text-black/70">
          <a href="tel:+18001234567" className="flex items-center gap-2 hover:text-[#000000] transition-colors">
            <Phone size={14} />
            <span className="hidden sm:inline">+1 (877) 787-8180	</span>
            <span className="sm:hidden">+1 (877) 787-8180	</span>
          </a>
          <a href="mailto:info@trademarklegalforum.com" className="hidden sm:flex items-center gap-2 hover:text-[#000000] transition-colors">
            <Mail size={14} />
            <span>info@trademarklegalforum.com</span>
          </a>
          <div className="hidden sm:flex items-center gap-2">
            <MapPin size={14} />
            <span>1370 N St Andrews Pl, Los Angeles, CA 90028</span>
          </div>
        </div>
      </div>
    </div>
  );
}
